export const isTallVideoCardTitle = (titleHeight: number | undefined) => (titleHeight || 0) > 30;
